var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_vm._l((_vm.getJobItems),function(row){return [_c('FormRow',{key:row.name,attrs:{"id":row.id,"name":row.name,"urls":row.urls}})]}),_c('button',{staticClass:"addNewRow",on:{"click":_vm.addNewRow}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }